import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import { Button } from '@shared/components/ui/button';
import { cn } from '@shared/lib/utils';

interface CardPagerProps {
  /** Current page, 1-based. */
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  className?: string;
}

/**
 * Compact pager for a short list inside a dashboard card or panel.
 * Renders nothing when there is only one page.
 */
export function CardPager({
  page,
  pageCount,
  onPageChange,
  className,
}: CardPagerProps) {
  if (pageCount <= 1) return null;

  return (
    <div className={cn('flex items-center gap-1', className)}>
      <Button
        aria-label="Previous page"
        variant="ghost"
        size="icon"
        className="size-7"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        icon={<Icons.chevronLeft className="size-4" />}
      />
      <Text variant="subtle" className="text-xs tabular-nums">
        {page} of {pageCount}
      </Text>
      <Button
        aria-label="Next page"
        variant="ghost"
        size="icon"
        className="size-7"
        disabled={page >= pageCount}
        onClick={() => onPageChange(page + 1)}
        icon={<Icons.chevronRight className="size-4" />}
      />
    </div>
  );
}
